import type {AiChatAnimationMetadata} from '@Components/ai-chat-window/ai-chat-window.types';

export enum AnimationCreationStatus {
  IDLE = 'idle',
  CREATING = 'creating',
  COMPLETED = 'completed',
  FAILED = 'failed',
  STOPPED = 'stopped',
}

export interface AiChatAnimation {
  animationHashedId: string;
  animationUrl: string;
  thumbnailUrl: string;
  width: number;
  height: number;
  duration: number;
  hasAudio: boolean;
  model: string;
  startTime?: number;
  endTime?: number;
}

export interface AnimationCreationState {
  isVisible: boolean;
  status: AnimationCreationStatus;
  animations?: AiChatAnimation[];
  errorMessage?: string;
  abortController?: AbortController;
  pollingKey?: string;
}

export const CHAT_MESSAGES_CONTAINER_ID = 'pmw-chat-messages-container';

export const ANIMATION_CREATION_SCROLL_NUDGE_PX = 250;

export const ANIMATION_CREATION_SCROLL_NUDGE_DESKTOP_PX = 400;

export interface AssistantMessageImagePartAnimationCreationsProps {
  chatId: string;
  hashedId: string;
  animations?: AiChatAnimationMetadata[];
  imageWidth?: number | null;
  imageHeight?: number | null;
}
